import React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import LoginPage from './modules/home/login'
import PageNotFound from "./components/404"
import Dashboard from "./modules/home/dashboard"
import Users from "./modules/users/users"

const MainRouter =(props:any)=>{

    return (
        <BrowserRouter>
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/*" element={<PageNotFound />} />
                
        </Routes>
        </BrowserRouter>
    )
}
export default MainRouter;